/* Subscriptions page modules (sections/elysian-plans.liquid), round 2, 2026-09-30.
   1. Gift listed totals: each length tile's price follows the chosen coffee and size (data-ely-gift-price, keyed "coffee line|size").
   2. Wired modules: keeps the form's hidden variant id and selling_plan in step with the choices. The map (data-ely-cart-map) is keyed
      "coffee line|size|grind|length" in lower case, empty where the product has no such option; each entry is {v: variant id,
      p: {weeks: selling plan id}} (gift: weeks "0"). Liquid fills the defaults, so without this file the default choice still adds.
      A combination with no variant or plan disables the button rather than adding the wrong bag.
   3. 2026-10-20 (trust batch, critic fix 11): the first-delivery offer tile ([data-ely-plan-deal], sections/elysian-plans.liquid) follows
      the choice: map entries also carry c (everyday one-time price) and s ({weeks: plan price}), in cents. first = plan price less the
      tile's percent, rounded to the cent (the product page's rule); saving = everyday less first; then = the plan price. A Subscribe add
      first sets the tile's code on the cart (same-origin fetch to /discount/CODE, redirect not followed, at most 2.5 s, then the add goes
      ahead regardless), exactly as elysian-product.js does on the product page, so the cart charges the price the tile shows. */
(function () {
  if (window.elySubsCartBound) return;
  window.elySubsCartBound = true;

  function lc(s) { return (s || '').trim().toLowerCase(); }
  function money(c) {
    var d = Math.round(c) / 100;
    return '$' + (Math.round(c) % 100 === 0 ? String(Math.round(d)) : d.toFixed(2));
  }
  function picked(mod, attr) {
    var el = mod.querySelector('[' + attr + ']:checked');
    return el ? lc(el.getAttribute(attr)) : '';
  }

  function bind(mod) {
    if (mod.hasAttribute('data-ely-cart-bound')) return;
    mod.setAttribute('data-ely-cart-bound', '');
    var gift = mod.hasAttribute('data-ely-gift');
    var prices = [];
    Array.prototype.forEach.call(mod.querySelectorAll('[data-ely-gift-price]'), function (el) {
      try { prices.push({ el: el, map: JSON.parse(el.getAttribute('data-ely-gift-price')) }); } catch (e) {}
    });
    var map = null;
    var mapEl = mod.querySelector('[data-ely-cart-map]');
    if (mapEl) { try { map = JSON.parse(mapEl.textContent); } catch (e) { map = null; } }
    var idIn = mod.querySelector('[data-ely-cart-id]');
    var planIn = mod.querySelector('[data-ely-cart-plan]');
    var btn = mod.querySelector('[data-ely-cart-submit]');
    var deal = mod.querySelector('[data-ely-plan-deal]');
    var dealPct = deal ? parseFloat(deal.getAttribute('data-pct')) || 0 : 0;
    function setText(sel, t) { var el = deal.querySelector(sel); if (el && el.textContent !== t) el.textContent = t; }

    function sync() {
      var c = mod.querySelector('[data-ely-sub-coffee]:checked');
      var ci = c ? c.value : '1';
      var size = picked(mod, 'data-ely-cart-sz');
      if (gift) {
        prices.forEach(function (p) {
          var v = p.map[ci + '|' + size];
          if (v && p.el.textContent !== v) p.el.textContent = v;
        });
      }
      if (!map || !idIn || !planIn || !btn) return;
      var tile = picked(mod, 'data-ely-cart-tile');
      var grind = picked(mod, 'data-ely-cart-g');
      var key = gift ? ci + '|' + size + '|' + grind + '|' + tile : ci + '|' + tile + '|' + grind + '|';
      var weeks = gift ? '0' : (picked(mod, 'data-ely-cart-weeks') || '0');
      var entry = map[key];
      var plan = entry && entry.p ? entry.p[weeks] : null;
      if (entry) idIn.value = entry.v;
      if (plan) planIn.value = plan;
      btn.disabled = !(entry && plan);
      if (deal && entry && entry.s && entry.s[weeks] != null && entry.c != null) {
        var then = entry.s[weeks], first = Math.round(then * (100 - dealPct) / 100), every = weeks === '1' ? 'week' : weeks + ' weeks';
        setText('[data-ely-plan-first]', money(first));
        setText('[data-ely-plan-was]', money(entry.c));
        setText('[data-ely-plan-saving]', 'Save ' + money(entry.c - first) + ' today.');
        setText('[data-ely-plan-renew]', 'Then ' + money(then) + ' every ' + every + '.');
        setText('[data-ely-plan-sr]', 'First delivery ' + money(first) + ', was ' + money(entry.c) + '.');
      }
    }
    var code = deal ? (deal.getAttribute('data-code') || '').trim() : '';
    var form = idIn ? idIn.form : null;
    var passing = false;
    if (form && code && dealPct > 0 && window.fetch) {
      document.addEventListener('submit', function (e) {
        if (e.target !== form || passing) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var done = false;
        function go() {
          if (done) return; done = true; passing = true;
          try {
            if (form.requestSubmit) form.requestSubmit();
            else { var ev = new Event('submit', { bubbles: true, cancelable: true }); if (form.dispatchEvent(ev)) form.submit(); }
          } finally { passing = false; }
        }
        setTimeout(go, 2500);
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' }).then(go, go);
      }, true);
    }
    mod.addEventListener('change', sync);
    sync();
  }

  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-ely-sub]'), bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
